import React from "react";
import { CustomSparklesIcon } from "./icons";

interface IButtonProps {
	title: string;
	onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
	loadingTitle?: string;
	isLoading?: boolean;
	disabled?: boolean;
	icon?: React.ReactNode;
}

/**
 * ACTION BUTTON
 * Primary gradient action button with sparkle icon.
 */
export const ActionButton = ({
	title,
	onClick,
	loadingTitle,
	isLoading = false,
	disabled,
	icon,
}: IButtonProps) => {
	return (
		<div className="w-full flex justify-center">
			<button
				onClick={onClick}
				disabled={disabled}
				style={{ background: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)" }}
				className="w-full flex items-center justify-center gap-2 text-white text-sm font-semibold px-4 py-2.5 rounded-full shadow-[0_4px_20px_-4px_rgba(59,130,246,0.35)] hover:shadow-[0_8px_28px_-6px_rgba(59,130,246,0.45)] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150"
			>
				{isLoading ? (
					<>
						<svg className="animate-spin w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none">
							<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
							<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
						</svg>
						<span>{loadingTitle ?? title}</span>
					</>
				) : (
					<>
						{icon ?? <CustomSparklesIcon />}
						<span>{title}</span>
					</>
				)}
			</button>
		</div>
	);
};
